module.exports = __webpack_public_path__ + "static/media/Prata-da-Casa.ece55433.pdf";